/* STAAL / het verhaal van één accessoire (editie 2, 09-10-2026)
   Hoort bij snippets/staal-acc-verhaal.liquid en assets/staal-acc.css.

   - Los / Op de fiets: de knop zet data-stand op het podium. Eerst laden en
     decoderen we wat er straks te zien is, dan pas wisselt het beeld (nooit
     een lege of halve foto). De eerste keer in beeld gaat hij één keer
     vanzelf over, zoals "Plat in één draai".
   - Kies je fiets: de gekozen fiets rijdt het beeld in, de vorige rijdt eruit;
     daarna valt het accessoire erop (CSS, met een kleine veer).
   - Kleur: kies je in de koopkolom een andere kleur, dan wisselt het
     accessoire op het podium mee (we kijken naar [data-kleur-naam]).
   - Cijfers tellen één keer op als ze in beeld komen.
   Met "minder beweging" staat alles meteen goed. */
(function () {
  'use strict';
  var stil = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var lijst = function (x) { return Array.prototype.slice.call(x || []); };

  function laad(img) {
    if (img.hasAttribute('data-src')) {
      if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
    img.loading = 'eager';
    if (img.complete && img.naturalWidth) return Promise.resolve();
    return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
  }
  function wacht(imgs, max) {
    return Promise.race([
      Promise.all(imgs.map(laad)),
      new Promise(function (ok) { setTimeout(ok, max || 2500); })
    ]);
  }

  function podium(root, pod) {
    var soort = pod.getAttribute('data-soort');
    var standKnoppen = lijst(pod.querySelectorAll('[data-ax-stand]'));
    var fietsKnoppen = lijst(pod.querySelectorAll('[data-ax-fiets]'));
    var stapels = lijst(pod.querySelectorAll('[data-ax-stapel]'));
    var keus = pod.querySelector('.ax-keus');
    var pil = keus && keus.querySelector('.ax-keus__pil');
    var naam = pod.querySelector('[data-ax-naam]');
    var naamTekst = pod.querySelector('[data-ax-naam-tekst]');
    var nu = 0, zelf = false, beurtStand = 0, beurtFiets = 0;

    var kleur = function () { return pod.getAttribute('data-kleur') || 'zwart'; };
    var beeldenVan = function (st) {
      return st ? lijst(st.querySelectorAll('.ax-fiets-img, .ax-wis, .ax-laag[data-kleur="' + kleur() + '"]')) : [];
    };
    var beeldenOp = function () {
      if (soort === 'laag') return beeldenVan(stapels[nu]);
      return lijst(pod.querySelectorAll('.ax-op img, .ax-los__img--twee'));
    };

    /* de camera: na het landen zoomt hij in op het accessoire. Wie zelf op het
       knopje drukt, bepaalt het daarna zelf. Bij inzoomen vragen we grotere
       beelden op (sizes), dan blijft hij scherp. */
    var zoomKnop = pod.querySelector('[data-ax-zoom]');
    var zoomWil = true, zoomTik = 0, camTik = 0;
    function zetZoom(aan) {
      if (!zoomKnop) return;
      if ((pod.getAttribute('data-zoom') === '1') === aan) return;
      if (aan) stapels.forEach(function (st) {
        var px = Math.round(st.offsetWidth * 1.9) + 'px';
        lijst(st.querySelectorAll('img')).forEach(function (im) { im.sizes = px; });
      });
      pod.classList.add('is-camera');
      clearTimeout(camTik);
      camTik = setTimeout(function () { pod.classList.remove('is-camera'); }, 1600);
      pod.setAttribute('data-zoom', aan ? '1' : '0');
      zoomKnop.setAttribute('aria-pressed', aan ? 'true' : 'false');
      zoomKnop.setAttribute('aria-label', zoomKnop.getAttribute(aan ? 'data-uit' : 'data-in'));
    }
    if (zoomKnop) zoomKnop.addEventListener('click', function () {
      zelf = true;
      clearTimeout(zoomTik);
      zoomWil = pod.getAttribute('data-zoom') !== '1';
      zetZoom(zoomWil);
    });

    function zetStand(stand) {
      if (!standKnoppen.length) return;
      var b = ++beurtStand;
      standKnoppen.forEach(function (k) { k.setAttribute('aria-pressed', k.getAttribute('data-ax-stand') === stand ? 'true' : 'false'); });
      clearTimeout(zoomTik);
      var klaar = function () {
        if (b !== beurtStand) return;
        if (stand === 'los') zetZoom(false);
        pod.setAttribute('data-stand', stand);
        /* eerst laten landen (de fiets rijst op, het accessoire valt erop), dan inzoomen */
        if (stand === 'op' && zoomKnop && zoomWil) zoomTik = setTimeout(function () { if (b === beurtStand) zetZoom(true); }, stil ? 0 : 1500);
      };
      if (stand === 'op') wacht(beeldenOp(), 2200).then(klaar); else klaar();
    }
    standKnoppen.forEach(function (k) {
      k.addEventListener('click', function () { zelf = true; zetStand(k.getAttribute('data-ax-stand')); });
    });

    /* de pil van de fietskeuze: meten, niet raden (de knoppen kunnen ook op twee regels staan) */
    function zetPil(direct) {
      if (!pil) return;
      var k = fietsKnoppen[nu];
      if (!k) return;
      if (direct) pil.style.transition = 'none';
      pil.style.setProperty('--kx', k.offsetLeft + 'px');
      pil.style.setProperty('--ky', k.offsetTop + 'px');
      pil.style.setProperty('--kw', k.offsetWidth + 'px');
      pil.style.setProperty('--kh', k.offsetHeight + 'px');
      if (direct) { void pil.offsetWidth; pil.style.transition = ''; }
      keus.classList.add('is-klaar');
    }
    if (pil) {
      (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(function () { zetPil(true); });
      window.addEventListener('resize', function () { zetPil(true); }, { passive: true });
    }

    function kiesFiets(i) {
      if (i === nu || !stapels[i]) return;
      zelf = true;
      var vorige = nu;
      nu = i;
      fietsKnoppen.forEach(function (k, j) { k.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      zetPil(false);
      var b = ++beurtFiets;
      wacht(beeldenVan(stapels[i]), 2500).then(function () {
        if (b !== beurtFiets) return;
        var richting = i > vorige ? 1 : -1;
        var st = stapels[i];
        /* de nieuwe begint aan de kant waar je naartoe kiest, de oude gaat de andere kant op */
        st.style.transition = 'none';
        st.style.setProperty('--x', (richting * 8) + '%');
        void st.offsetWidth;
        st.style.transition = '';
        stapels.forEach(function (s, j) {
          if (j === i) return;
          if (s.classList.contains('is-nu')) s.style.setProperty('--x', (-richting * 8) + '%');
          s.classList.remove('is-nu');
        });
        st.classList.add('is-nu');
        if (naam) { naam.href = st.getAttribute('data-url'); if (naamTekst) naamTekst.textContent = st.getAttribute('data-naam'); }
        if (pod.getAttribute('data-stand') !== 'op') zetStand('op');
      });
    }
    fietsKnoppen.forEach(function (k) {
      k.addEventListener('click', function () { kiesFiets(+k.getAttribute('data-ax-fiets')); });
    });
    /* wie naar de fietskeuze gaat, krijgt de andere fietsen alvast klaar */
    if (keus) {
      var vooraf = function () {
        keus.removeEventListener('pointerenter', vooraf);
        keus.removeEventListener('focusin', vooraf);
        stapels.forEach(function (s) { beeldenVan(s).forEach(laad); });
      };
      keus.addEventListener('pointerenter', vooraf);
      keus.addEventListener('focusin', vooraf);
    }

    /* kleur uit de koopkolom */
    var kn = root.querySelector('[data-kleur-naam]');
    if (kn && pod.querySelector('.ax-los__img[data-kleur="zilver"]') && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var k = /silver|zilver/i.test(kn.textContent || '') ? 'zilver' : 'zwart';
        if (k === kleur()) return;
        var imgs = lijst(pod.querySelectorAll('.ax-los__img[data-kleur="' + k + '"]'));
        if (stapels[nu]) imgs = imgs.concat(lijst(stapels[nu].querySelectorAll('.ax-laag[data-kleur="' + k + '"]')));
        wacht(imgs, 2000).then(function () { pod.setAttribute('data-kleur', k); });
      }).observe(kn, { childList: true, characterData: true, subtree: true });
    }

    /* één keer vanzelf: eerst los laten zien, dan op de fiets */
    if (standKnoppen.length) {
      if (stil || !('IntersectionObserver' in window)) {
        if (stil) zetStand('op');
        return;
      }
      var demo = new IntersectionObserver(function (l) {
        if (!l[0].isIntersecting) return;
        demo.disconnect();
        var t0 = Date.now();
        wacht(beeldenOp(), 3000).then(function () {
          setTimeout(function () { if (!zelf) zetStand('op'); }, Math.max(0, 1300 - (Date.now() - t0)));
        });
      }, { threshold: .6 });
      demo.observe(pod.querySelector('[data-ax-beeld]') || pod);
    }
  }

  /* de cijfers tellen op: 0 → 92, 0 → 8,5 */
  function cijfers(ax) {
    var tellers = lijst(ax.querySelectorAll('[data-ax-tel]')).filter(function (el) {
      return /^\d+(,\d+)?$/.test(el.getAttribute('data-ax-tel'));
    });
    if (!tellers.length || stil || !('IntersectionObserver' in window)) return;
    /* vooraf: de breedte vastzetten en op nul zetten, zodat er niets verspringt of flitst */
    tellers.forEach(function (el) {
      var dec = (el.getAttribute('data-ax-tel').split(',')[1] || '').length;
      el.style.display = 'inline-block';
      el.style.minWidth = el.offsetWidth + 'px';
      el.textContent = (0).toFixed(dec).replace('.', ',');
    });
    var io = new IntersectionObserver(function (l) {
      l.forEach(function (x) {
        if (!x.isIntersecting) return;
        io.unobserve(x.target);
        var el = x.target, doel = el.getAttribute('data-ax-tel');
        var dec = (doel.split(',')[1] || '').length;
        var waarde = parseFloat(doel.replace(',', '.'));
        var start = null;
        var stap = function (t) {
          if (start === null) start = t;
          var p = Math.min(1, (t - start) / 1200), e = 1 - Math.pow(1 - p, 3);
          el.textContent = (waarde * e).toFixed(dec).replace('.', ',');
          if (p < 1) requestAnimationFrame(stap); else el.textContent = doel;
        };
        setTimeout(function () { requestAnimationFrame(stap); }, 180);
      });
    }, { threshold: .8 });
    tellers.forEach(function (el) { io.observe(el); });
  }

  function init(ax) {
    if (ax.hasAttribute('data-ax-klaar')) return;
    ax.setAttribute('data-ax-klaar', '');
    var root = ax.closest('[data-pdp]') || document;
    var pod = ax.querySelector('[data-ax-podium]');
    if (pod) podium(root, pod);
    cijfers(ax);
  }
  function boot() { lijst(document.querySelectorAll('[data-ax]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
